import Vue from "vue";
//import moment from 'moment';
import * as moment from 'moment/moment';
import _ from 'lodash';
Object.defineProperty(Vue.prototype, '_', { value: _ });


// NEED TO CONSIDER userRoles, userFunctions in the future
Vue.filter("adminAccessFtie", function (userName, userRoles, userFunctions) {
  let managerAdminList = ['power', 'richard.lee', 'honda.yeh', 'alice.cy.lee', 'mark.tsai'];
  if (_.indexOf(managerAdminList, userName) > -1) {
    return true;
  }
  return false;
});

Vue.filter("frontendUrl", function () {
  let hostName = location.host;
  console.log("[Filter frontendUrl] hostName=" + hostName);
  let frontendUrl = _.trim(process.env.FRONTEND_URL) + '/';
  if (hostName && hostName.indexOf('uatftie') !== -1) {
    frontendUrl = _.trim(process.env.UAT_FRONTEND_URL) + '/';
  }
  return frontendUrl;
});

Vue.filter("uatFrontendUrl", function () {
  let frontendUrl = _.trim(process.env.UAT_FRONTEND_URL) + '/';
  return frontendUrl;
});

Vue.filter("frontendUrlbyRoles", function (routerName, userName, userRoles, userFunctions, userRegions) {
  let frontendUrl = _.trim(process.env.FRONTEND_URL) + '/';
  // HOW TO USE: {{ user_name,user_roles,user_functions, user_site | frontendUrlbyRoles }}

  // let frontEndPath = self.$options.filters['frontendUrlbyRoles'](self.currentRouteName, self.user_name, self.user_roles, self.user_functions, self.user_site);
  // let frontEndPath = self.$options.filters['frontendUrlbyRoles'](self.$route.name, self.user_name, self.user_roles, self.user_functions, self.user_site);
  console.log("frontendUrlbyRoles INPUT(routerName, userName, userRoles, userFunctions, userRegions):");
  console.log(routerName);
  console.log(userName);
  console.log(userRoles);
  console.log(userFunctions);
  console.log(userRegions);
  let uatRouterNameList = ['Home', 'FTIE Dashboard', 'FTIE Page', 'Request Form', 'FTIE Page Dashboard', 'Assign RD Function', 'RD Check Item'];
  if (_.indexOf(uatRouterNameList, routerName) > -1) {
    if ((userRoles && _.indexOf(userRoles, 'Admin') > -1)
      || (userFunctions && _.indexOf(userFunctions, 'ES PM Leader') > -1)
      || (userRoles && _.indexOf(userRoles, 'ES_PM') > -1)
      || (userRoles && _.indexOf(userRoles, 'ES_PM_Leader') > -1)
      || (userFunctions && _.indexOf(userFunctions, 'Tech Leader') > -1)
      || (userRoles && _.indexOf(userRoles, 'HQ_ES') > -1)
      || (userRegions && _.indexOf(userRegions, 'Getac') > -1)
    ) {
      console.log("Access to ETO V4 (PT/UAT Site) for RouterName is " + routerName);
      // frontendUrl = _.trim(process.env.UAT_FRONTEND_URL) + '/';
      frontendUrl = _.trim(process.env.FRONTEND_URL) + '/';
    }
  }
  console.log("frontendUrlbyRoles Result =");
  console.log(frontendUrl);
  return frontendUrl;
});


Vue.filter("authUrl", function () {
  let authUrl = _.trim(process.env.AUTH_URL) + '/';
  return authUrl;
});

Vue.filter("salesforceUrl", function () {
  let sfUrl = _.trim(process.env.SALESFORCE_URL); //+ '/';
  return sfUrl;
});

Vue.filter("ftieTwUrl", function () {
  let ftieTwUrl = _.trim(process.env.FTIE_V3) + '/';
  return ftieTwUrl;
});

Vue.filter("clientId", function () {
  return process.env.CLIENT_ID;
});


Vue.filter("getInputLength", function (value) {
  if (value !== null) {
    return value.length;
  }
  return 0;
});

Vue.filter("reachLength", function (value, maxLength) {
  if (value !== null) {
    return maxLength < value.length;
  }
  return false;
});

Vue.filter('dateFormat', function (value, format) {

  // https://momentjs.com/docs/#/displaying/format/

  if (_.isNil(format) || _.trim(format) == '') {
    format = 'YYYY-MMM-DD';
  }

  var d = moment(value);
  if (!d.isValid()) {
    return '';
  }
  else {
    return d.format(format);
  }
})


Vue.filter('dateTimeFormat', function (value, format) {

  // https://momentjs.com/docs/#/displaying/format/

  if (_.isNil(format) || _.trim(format) == '') {
    format = 'YYYY-MMM-DD HH:mm:ss';
  }

  var d = moment(value);
  if (!d.isValid()) {
    return '';
  }
  else {
    return d.format(format);
  }
})

Vue.filter('firstNameOnly', function (value, format) {

  // https://momentjs.com/docs/#/displaying/format/

  if (_.isNil(value) || _.trim(value) == '' || value == "SKIP") {
    return '';
  }

  let output = value.split(/[ ._]/, 1)[0];
  // first character upperCase
  return output.charAt(0).toUpperCase() + output.slice(1);
})

Vue.filter('etoSignStausFormat', function (value, format) {

  let output = value;
  if ('W' === value) {
    output = 'Waiting';
  } else if ('S' === value) {
    output = 'Submit';
  } else if ('R' === value) {
    output = 'Reject';
  }
  return output;
})



// WEBPACK FOOTER //
// ./src/helpers/filters.js